import { serverUri } from 'src/config'
import Model, { Integer, MODEL_LEVEL } from 'src/models/Model'
export default class MarketingList extends Model {
  static name = 'MarketingList'
  static noId = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Marketing, Model.permissionCategories.Data]

  static define () {
    this.fields = {
      listType: {
        type: String,
        output: true
      },
      listDescription: {
        type: String,
        output: true
      },
      numberOfSubscribers: {
        type: Integer,
        output: true
      }
    }
  }

  get downloadUrl () {
    return `${serverUri}/mailing_list?site_id=${this.configuration.currentSite.id}&marketing_column_name=${this.listType.replaceAll(' ', '_')}`
  }
}
